(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-optimized-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const containers = document.querySelectorAll('[data-video-container]');
    containers.forEach(container => {
      const video = container.querySelector('video');
      const customBtn = container.querySelector('[data-video-control]');
      if (!video || !customBtn) return;

      let hasStarted = false;

      function loadAndPlay() {
        if (video.src && video.src !== '') return Promise.resolve();
        const src = video.getAttribute('data-src');
        if (src) {
          video.src = src;
          video.load();
        }
        return video.play().catch(e => console.warn('Play failed:', e));
      }

      // Handle initial load when clicking on video (before first play)
      video.addEventListener('click', (e) => {
        if (!hasStarted) {
          e.preventDefault(); // prevent any stray default behavior
          loadAndPlay().then(() => {
            hasStarted = true;
            video.controls = true;   // show native controls after first play
            customBtn.style.display = 'none';
          }).catch(() => {});
        }
        // If already started, do nothing – let browser's default toggle work
      });

      // Custom button click: always toggle play/pause (works both before and after start)
      customBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!hasStarted) {
          loadAndPlay().then(() => {
            hasStarted = true;
            video.controls = true;
            customBtn.style.display = 'none';
          }).catch(() => {});
        } else {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      });

      // Update custom button visibility based on play/pause state
      video.addEventListener('play', () => {
        customBtn.style.display = 'none';
        if (!hasStarted) {
          hasStarted = true;
          video.controls = true;
        }
      });
      video.addEventListener('pause', () => {
        // Only show button if video has been started (to avoid showing it on initial black screen)
        if (hasStarted) {
          customBtn.style.display = 'block';
        }
      });

      // Initial state: button visible
      customBtn.style.display = 'block';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
